<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">公积金专区</li>
    </ul>
    <ul class="c-list-search">
      <el-input
        v-model="state.params.name"
        style="width: 200px"
        placeholder="名称"
        clearable
        @clear="
          delete state.params.name;
          onLoad();
        "
      ></el-input>
      <el-cascader
        v-model="state.area"
        :options="state.areaData"
        :props="{ label: 'name', value: 'name' }"
        placeholder="--所属地区--"
        clearable
        filterable
        @change="onAreaChange"
        @clear="
          delete state.params?.province;
          delete state.params?.city;
          delete state.params?.district;
        "
      />
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column prop="name" label="名称" width="300" />
        <el-table-column
          prop="fund_limit"
          label="公积金上限"
          :formatter="$tab_MoneyFormat"
          width="200"
        />
        <el-table-column
          label="所属地区"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.province + (row.city || '') + (row.district || ''),
                ''
              )
          "
          width="300"
        />
        <el-table-column
          prop="address"
          label="所在地址"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="操作"
          width="220"
          align="center"
          fixed="right"
          className="tabBtn"
          v-if="$judge_auth('33')"
        >
          <template #default="{ row }">
            <el-button
              type="warning"
              link
              icon="Sort"
              @click="
                state.selectItem = row;
                state.showEdit = true;
              "
            >
              调整公积金上限
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <el-dialog
      v-model="state.showEdit"
      title="调整公积金上限"
      width="400px"
      align-center
      @close="state.selectItem = {}"
      style="--el-dialog-padding-primary: 0"
    >
      <template #title>
        <div
          style="
            display: flex;
            align-items: center;
            height: 48px;
            padding-left: 10px;
          "
        >
          调整公积金上限
        </div>
      </template>
      <ul
        style="
          border-top: 1px solid #e2e2e2;
          padding-top: 20px;
          text-align: center;
          font-size: 18px;
        "
      >
        {{
          state.selectItem?.name
        }}
      </ul>
      <ul style="text-align: center; margin: 20px 0">
        <el-input-number
          v-model="state.selectItem.fund_limit"
          style="width: 50%"
          :precision="2"
          size="large"
        ></el-input-number>
      </ul>
      <ul
        style="
          display: flex;
          justify-content: flex-end;
          padding-right: 20px;
          padding-bottom: 20px;
        "
      >
        <el-button
          @click="
            state.showEdit = false;
            state.selectItem = {};
          "
          >取消</el-button
        >
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </ul>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { taxbureau_list, taxbureau_edit } from "@/http/taxbureau";
import { data_areacode_tree } from "@/http/data";
import { ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
  };
}
export default {
  setup() {
    const state = reactive({ ...new InitFormData(), selectItem: {} });
    onMounted(() => {
      onLoadAreaCode();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      taxbureau_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    const onLoadAreaCode = () => {
      data_areacode_tree().then((res) => {
        if (res.status == 200) state.areaData = res.data.data?.list;
      });
    };

    const onAreaChange = (value) => {
      if (value?.length == 3) {
        state.params.province = value[0];
        state.params.city = value[1];
        state.params.district = value[2];
      }
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.area;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const onSubmit = () => {
      if (
        state.selectItem.fund_limit == null ||
        state.selectItem.fund_limit == undefined
      ) {
        ElMessage.warning("请填写要调整的公积金上限！");
        return false;
      }

      taxbureau_edit(state.selectItem).then((res) => {
        if (res.status == 200) {
          ElMessage.success(res.data.msg);
          state.showEdit = false;
          onLoad();
        }
      });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onAreaChange,
      onReset,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
